export default {
    title: "Servers",
    description: "This page will give you an overview of what game servers we are hosting at the moment.",
    games: {
        minecraft: {
            title: "Minecraft",
            versionLabel: "Version",
            ipLabel: "IP/Hostname",
            portLabel: "Port",
            onlinePlayersLabel: "Players online",
            statusLabel: "Status"
        }
    }
}